/*
 * Droits sur les modèles immo (propriétaire vs utilisateur secondaire).
 * Source unique pour le footer carte, la liste tableau et la vue vignettes.
 * @param getUser
 * @param donnees
 * @returns {boolean}
 */
export function isModelOwner (getUser, donnees) {
  const userEmail = (getUser && getUser.identifierCode === 'EMAIL_A_AFFICHER') ? getUser.identifierValue : null
  const modelEmail = (donnees && donnees.email_a_afficher) ? donnees.email_a_afficher.valeur : null
  if (!userEmail || !modelEmail) return false

  return userEmail.trim().toLowerCase() === modelEmail.trim().toLowerCase()
}

/**
 * Permet d'autoriser la suppression du model selon les droits
 * @param isSubUser
 * @param getUser
 * @param donnees
 * @returns {boolean}
 */
export function canDeleteModel (isSubUser, getUser, donnees) {
  if (!isSubUser) {
    return true
  }
  return isModelOwner(getUser, donnees)
}

/**
 * Sélection en liste (cases à cocher) : les modèles ne sont sélectionnables
 * par un sous-utilisateur que s'il en est propriétaire (même règle que canDeleteModel).
 *
 * @param {boolean} isSubUser
 * @param {Object|null} getUser
 * @param {{ etat: string, donnees?: object }} row - ligne API liste annonces
 */
export function canSelectPostForBulk (isSubUser, getUser, row) {
  if (!row) return false
  if (row.etat !== 'M') return true
  return canDeleteModel(isSubUser, getUser, row.donnees)
}
